<div>
  @if (
    column.inputType === gridInputTypes.date ||
    column.inputType === gridInputTypes.time ||
    (column.inputType === gridInputTypes.dateTime && column.template === undefined)
  ) {
    <span
      [title]="column | tooltipTitle: toolTipVisible : dataItem"
      [attr.data-cy]="column.field | cypressName: 'column'"
      [innerHTML]="dataItem[column.field] | gridColumnFormat: column"></span>
  }

  <!-- format boolean|select|password -->
  @if (
    column.inputType === gridInputTypes.boolean ||
    column.inputType === gridInputTypes.switch ||
    column.inputType === gridInputTypes.password ||
    column.inputType === gridInputTypes.select ||
    column.inputType === gridInputTypes.string ||
    column.inputType === gridInputTypes.colorPicker ||
    column.inputType === gridInputTypes.textArea ||
    column.inputType === gridInputTypes.label ||
    column.inputType === gridInputTypes.upload ||
    column.inputType === gridInputTypes.checkbox ||
    column.inputType === gridInputTypes.multiColumnSelect ||
    column.inputType === gridInputTypes.multiSelect ||
    column.inputType === gridInputTypes.fileSelect ||
    column.inputType === gridInputTypes.number ||
    column.inputType === gridInputTypes.codeMirror ||
    (!column.inputType && column.template === undefined)
  ) {
    <ng-container>
      @if (column.template === undefined) {
        <ng-container>
          @switch (column.inputType) {
            @case (
              [gridInputTypes.boolean, gridInputTypes.switch].includes(column.inputType)
                ? column.inputType
                : !column.inputType
            ) {
              <!-- Boolean | Switch -->
              <span
                [title]="column | tooltipTitle: toolTipVisible : dataItem"
                [attr.data-cy]="column.field | cypressName: 'column'">
                @if (column.typeConfig?.booleanConfig?.asIcons && dataItem[column.field] === true) {
                  <fa-icon [icon]="faCheck" [attr.data-cy]="column.field | cypressName: 'column'"></fa-icon>
                }
                @if (column.typeConfig?.booleanConfig?.asIcons && dataItem[column.field] === false) {
                  <fa-icon [icon]="faTimes" [attr.data-cy]="column.field | cypressName: 'column'"></fa-icon>
                }
                @if (!column.typeConfig?.booleanConfig?.asIcons) {
                  <span
                    [attr.data-cy]="column.field | cypressName: 'column'"
                    [innerHTML]="getDataItemValue(dataItem, column)"></span>
                }
              </span>
              <!-- End Boolean -->
            }
            @case (gridInputTypes.select) {
              <!-- Select -->
              <span
                [title]="column | tooltipTitle: toolTipVisible : dataItem"
                [attr.data-cy]="column.field | cypressName: 'column'"
                [innerHTML]="getSelectDataItemValue(dataItem, column) | async"></span>
            }
            @case (gridInputTypes.multiColumnSelect) {
              <!-- Multi ColumnSelect -->
              <span
                [title]="column | tooltipTitle: toolTipVisible : dataItem"
                [attr.data-cy]="column.field | cypressName: 'column'"
                [innerHTML]="getSelectDataItemValue(dataItem, column) | async"></span>
            }
            @case (gridInputTypes.multiSelect) {
              <!-- Multiselect -->
              <span
                [title]="column | tooltipTitle: toolTipVisible : dataItem"
                [attr.data-cy]="column.field | cypressName: 'column'"
                [innerHTML]="getMultiSelectDataItemValue(dataItem, column) | async"></span>
            }
            @case (gridInputTypes.password) {
              <!-- Password -->
              <span
                [title]="column | tooltipTitle: toolTipVisible : dataItem"
                [attr.data-cy]="column.field | cypressName: 'column'"
                [innerHTML]="getDataItemValue(dataItem, column)"></span>
            }
            @case (gridInputTypes.fileSelect) {
              <!-- FileSelect -->
              <span
                [title]="column | tooltipTitle: toolTipVisible : dataItem"
                [attr.data-cy]="column.field | cypressName: 'column'">
                @for (file of getDataFileSelectValue(dataItem, column); track file) {
                  <ng-container>
                    <nexweb-file-for-download [file]="file"></nexweb-file-for-download>
                    &nbsp;
                  </ng-container>
                }
              </span>
            }
            @case (gridInputTypes.number) {
              <!-- Number -->
              <span
                [attr.data-cy]="column.field | cypressName: 'column'"
                [title]="column | tooltipTitle: toolTipVisible : dataItem"
                [innerHTML]="dataItem[column.field] | gridColumnFormat: column"></span>
            }
            @default {
              <!-- Default -->
              <span
                [attr.data-cy]="column.field | cypressName: 'column'"
                [title]="column | tooltipTitle: toolTipVisible : dataItem"
                [innerHTML]="dataItem ? dataItem[column.field] : ''"></span>
              <!-- End Default -->
            }
          }
        </ng-container>
      }
    </ng-container>
  }

  <!-- override value with template -->
  @if (column.template !== undefined) {
    <span
      [attr.data-cy]="column.field | cypressName: 'span'"
      [title]="column | tooltipTitle: toolTipVisible : dataItem"
      [innerHTML]="getAsTemplate(column.template, column, dataItem) | safeHtml"></span>
  }
</div>
